import { onExcelTemplateActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { ExcelTemplateActivityCard } from "./ExcelTemplateActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  excelTemplateId: number
  config: server.dto.ActivityPanelConfig
}

export const ExcelTemplateActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.ExcelTemplateActivity>
    activityKey="excelTemplate"
    itemId={props.excelTemplateId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ExcelTemplate.ListActivity({ itemId: props.excelTemplateId, page, perPage })}
    renderActivity={(activity => <ExcelTemplateActivityCard
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onExcelTemplateActivity}
    onActivity={(activity) => {
      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
